import type { SupportedLanguage } from './index'

/**
 * Define localized routes here.
 * Each key maps to a route name, with translations for each language.
 *
 * Example:
 *   about: { it: 'chi-siamo', en: 'about-us' }
 *   → /it/chi-siamo, /en/about-us
 */
export const localizedRoutes = {
  home: {
    it: '',
    en: '',
    fr: '',
    es: '',
    de: '',
    pl: '',
    pt: '',
  },
  about: {
    it: 'azienda',
    en: 'about',
    fr: 'about',
    es: 'about',
    de: 'about',
    pl: 'about',
    pt: 'about',
  },
  products: {
    it: 'prodotti',
    en: 'products',
    fr: 'products',
    es: 'products',
    de: 'products',
    pl: 'products',
    pt: 'products',
  },
  sustainability: {
    it: 'sostenibilita',
    en: 'sustainability',
    fr: 'sustainability',
    es: 'sustainability',
    de: 'sustainability',
    pl: 'sustainability',
    pt: 'sustainability',
  },
  news: {
    it: 'news',
    en: 'news',
    fr: 'news',
    es: 'news',
    de: 'news',
    pl: 'news',
    pt: 'news',
  },
  contacts: {
    it: 'contatti',
    en: 'contacts',
    fr: 'contacts',
    es: 'contacts',
    de: 'contacts',
    pl: 'contacts',
    pt: 'contacts',
  },
  cookie: {
    it: 'cookie-policy',
    en: 'cookie-policy',
    fr: 'cookie-policy',
    es: 'cookie-policy',
    de: 'cookie-policy',
    pl: 'cookie-policy',
    pt: 'cookie-policy',
  },
  privacy: {
    it: 'privacy',
    en: 'privacy',
    fr: 'privacy',
    es: 'privacy',
    de: 'privacy',
    pl: 'privacy',
    pt: 'privacy',
  },
  whistleblowing: {
    it: 'whistleblowing',
    en: 'whistleblowing',
    fr: 'whistleblowing',
    es: 'whistleblowing',
    de: 'whistleblowing',
    pl: 'whistleblowing',
    pt: 'whistleblowing',
  },
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
